import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router";
import { getCurrentAccessToken } from "./authSlice";
import { clearMfaChallenge, getPendingMfaRoute, isMfaChallengeValid } from "./mfaSlice";
import { useDispatch, useSelector } from "react-redux";
import type { RootState } from "store";

const MFA_ROUTES = ["/authcode", "/mfa", "/registrationauth"];
const RESTORE_CHALLENGE_PATHS = ["/", "/start"];

const selectHasStaleMfaChallenge = (state: RootState): boolean =>
  state.mfaState.challengeExpiresAt != null && !isMfaChallengeValid(state);

export default function PublicRoute() {
  const token = useSelector(getCurrentAccessToken);
  const location = useLocation();
  const dispatch = useDispatch();
  const pendingRoute = useSelector(getPendingMfaRoute);
  const hasStaleChallenge = useSelector(selectHasStaleMfaChallenge);

  useEffect(() => {
    if (hasStaleChallenge) {
      dispatch(clearMfaChallenge());
    }
  }, [hasStaleChallenge, dispatch]);

  if (token) {
    return <Navigate to="my-loans" replace />;
  }

  const path = location.pathname.toLowerCase();
  const isOnMfaRoute = MFA_ROUTES.includes(path);
  const shouldRestoreChallenge = RESTORE_CHALLENGE_PATHS.includes(path);

  if (pendingRoute && shouldRestoreChallenge && !isOnMfaRoute) {
    return <Navigate to={pendingRoute} replace />;
  }

  return <Outlet />;
}
